import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import EventDateItem from "../../../components/EventDateItem";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import { weekdays } from "../../../utils/date";

const Calendar = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const control = useAnimation();
  const [ref, inView] = useInView([]);
  const boxVariant = {
    hidden: {
      x: -200,
    },
    visible: {
      x: 0,
    },
  };
  const boxesVariant = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
  };
  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);
  return (
    <div
      className="calendar-wrapper"
      style={{
        backgroundImage: `url(${require("./../../../assets/images/bg-parallax.webp")})`,
      }}
    >
      <div className="parallax"></div>
      <div className="calendar-inner-wrapper py-5">
        <div className="container">
          <div className="row">
            <motion.div
              ref={ref}
              variants={boxVariant}
              initial="hidden"
              animate={control}
              transition={{ duration: 0.5 }}
              className="col-lg-3 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center"
            >
              <h4 className="mb-0 left-title">
                {getContent(content, "Reception days for citizens", lang)}
              </h4>
            </motion.div>
            <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
              <motion.div
                ref={ref}
                variants={boxesVariant}
                initial="hidden"
                animate={control}
                transition={{ duration: 1 }}
                className="row"
              >
                <EventDateItem
                  day={weekdays[1][lang]}
                  time_one="9:00-12:00"
                  time_two="15:00-17:00"
                />
                <EventDateItem
                  day={weekdays[3][lang]}
                  time_one="9:00-12:00"
                  time_two="15:00-17:00"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
